export const SKIP_ANIMATION_ON_RENDER = {
  from: "initial" as const,
  to: "initial" as const,
};
